import {ActivityIndicator, Image, Text, View} from "react-native";
import styles from "./styles";
import {Images} from "../../config";
import {useEffect, useState} from "react";
import axios from "axios";
import {useDispatch, useSelector} from "react-redux";
import Constants from 'expo-constants';
import {Button} from "react-native-paper";
import Tooltip from "react-native-walkthrough-tooltip";

const baseUrl = (Constants.experienceUrl == 'http://localhost:19006') ? 'https://shop2support.test' : Constants.experienceUrl;

export default function Loading({navigation, route}) {
    const [hasError, setErrorFlag] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [prompt,setPrompt] = useState(null)
    const[appLogo,setAppLogo] = useState(false)
    const [showToolTip,setShowToolTip] = useState(false)
    const dispatch = useDispatch()
    const id = route.params.appID
    const url = `${baseUrl}/wp-json/custom/v1/beneficiary?post_id=${id}`

    const fetchBeneficiary = async () => {
        try {
            setIsLoading(true);
            const response = await axios.get(url);
            return response
        } catch (error) {
            if(axios.isCancel(error)){
                console.log('Data fetching cancelled');
            } else{
                console.log(error)
                setErrorFlag(true);
                setIsLoading(false);
            }
        }
    };

    const onInstallPress = (deferredPrompt) => {
        deferredPrompt.prompt()
        window.location.reload()
    }

    let latePrompt = useSelector(state=>state.event.event)

    const isIos = () => {
        const userAgent = window.navigator.userAgent.toLowerCase();
        return /iphone|ipad|ipod/.test(userAgent);
    }

    const isInStandaloneMode = () => {
        return (('standalone' in window.navigator && window.navigator.standalone) ||
            window.matchMedia('(display-mode: standalone)').matches);
    };

    const isChrome = () => {
        return (/Chrome/.test(window.navigator.userAgent) && /Google Inc/.test(window.navigator.vendor));
    };

    const isIosChromeMobile = () => {
        return (/CriOS/i.test(navigator.userAgent) && /iphone|ipod|ipad/i.test(navigator.userAgent));
    };

    const isMobile = () => {
        return (/iPhone|iPad|iPod|Android/i.test(navigator.userAgent));
    };

    const isDesktop = () => {
        return !isMobile();
    };

    useEffect(() => {
        window.addEventListener("beforeinstallprompt", (e) => {
            console.log('setting prompt')
            e.preventDefault()
            setPrompt(e)
        });
        let showInstallMessage = true
        const source = axios.CancelToken.source()

        if(isInStandaloneMode() || isIosChromeMobile() || (isDesktop() && !isChrome())){
            console.log('not showing install message')
            //do not show install message for already installed PWA or
            // Chrome on iOS or
            // Safari Desktop or
            // Firefox Desktop
            showInstallMessage = false
        }

        if( (isIos() && isMobile())){
            setTimeout(() => {
                setShowToolTip(true)
            }, 2500)
        }

        if(!isLoading){
            fetchBeneficiary().then(async response => {
                if (response.status === 200) {
                    console.log('success fetching beneficiary')
                    setIsLoading(false);
                    console.log(isLoading)
                    dispatch({
                        type: 'UPDATE_APP_DETAILS',
                        payload: response.data.results
                    })
                    setAppLogo(response.data.results.logo)
                    if ('serviceWorker' in navigator) {
                        const registration = await navigator.serviceWorker.getRegistration();
                        console.log('registration',registration)
                        if (registration) {
                            registration.addEventListener("updatefound", () => {
                                console.log("Service Worker update found!");
                                caches.keys().then(cacheNames => {
                                    cacheNames.forEach(cacheName => {
                                        caches.delete(cacheName);
                                    });
                                });
                                window.location.reload(true);
                            });
                        } else {
                            console.log('service worker not in navigator')
                        }
                        navigator.serviceWorker.register('/sw.js')
                            .then((registration) => {
                                console.log('ServiceWorker registration successful with scope: ', registration.scope);
                                if (!showInstallMessage) {
                                    console.log('navigating to main')
                                    setIsLoading(false);
                                    navigation.navigate(
                                        'Main', {
                                            screen: 'BottomTabNavigator',
                                            params: {appData: response.data.results, isLoading: false},
                                            merge: true,
                                        });
                                    navigation.setParams({appData: response.data.results, isLoading: isLoading})
                                }

                                if(!isInStandaloneMode() && (isDesktop() || (isMobile() && !isIos() && isChrome()))){
                                    //if desktop and not stand alone then go to main screen after 45 secs
                                    console.log('Setting time out')
                                    setTimeout(() => {
                                        if(!prompt){
                                            navigation.navigate(
                                                'Main', {
                                                    screen: 'BottomTabNavigator',
                                                    params: {appData: response.data.results, isLoading: isLoading},
                                                    merge: true,
                                                });
                                            navigation.setParams({appData: response.data.results, isLoading: isLoading})
                                        }
                                    }, 50000)
                                }

                            })
                            .catch((error) => {
                                console.log('Service worker registration failed: ', error);
                                console.log('navigating to main')
                                setIsLoading(false);
                                navigation.navigate(
                                    'Main', {
                                        screen: 'BottomTabNavigator',
                                        params: {appData: response.data.results, isLoading: false},
                                        merge: true,
                                    });
                                navigation.setParams({appData: response.data.results, isLoading: isLoading})
                            });
                    } else {
                        navigation.navigate(
                            'Main', {
                                screen: 'BottomTabNavigator',
                                params: {appData: response.data.results, isLoading: isLoading},
                                merge: true,
                            });
                        navigation.setParams({appData: response.data.results, isLoading: isLoading})
                    }

                } else {
                    throw new Error("Failed to fetch offers");
                }
            });
        }
        return () => source.cancel("Data fetching cancelled");
    },[]);

    if(isLoading) {
        return (
            <View style={styles.container}>
                <View style={{alignItems: 'center'}}>
                    <Image source={Images.logo} style={styles.logo} resizeMode="contain"/>
                </View>
                <ActivityIndicator
                    size="large"
                    color="#27aef1"
                    style={styles.loading}
                />
            </View>
        )
    } else if(!isLoading) {
        if(isIos() && isMobile()){
            return(
            <View style={styles.containerIos}>
                <View style={{flexDirection:"column"}}>
                    <View style={{alignItems: 'center'}}>
                        <Image source={appLogo ? appLogo :  Images.logo} style={styles.logo} resizeMode="contain"/>
                    </View>
                    <View style={{flex:1}}>
                        <Text style={styles.instructions}>1) Press the Share button below under the address bar <Image source={Images.upload} style={styles.icons} resizeMode="contain" /></Text>
                    </View>
                    <View style={{flex:1}}>
                        <Text style={styles.instructions}>2) Scroll down to and tap "Add to Home Screen <Image source={Images.add} style={styles.icons} resizeMode="contain"  />"</Text>
                    </View>
                </View>
                <View style={{justifyContent: 'flex-end', flex: 1}}>
                    <Tooltip
                        onClose={()=>setShowToolTip(false)}
                        isVisible={showToolTip}
                        content={<View style={{marginVertical: 10, alignItems: "center"}}>
                            <Text>Press the Share button</Text>
                            <Text><Image source={Images.upload} style={styles.icons} resizeMode="contain"/></Text>
                        </View>}
                        placement="top"
                        useInteractionManager={true}
                        disableShadow={true}
                        closeOnChildInteraction={false}
                        childContentSpacing={0}
                    >
                        <View>
                            <Text> </Text>
                        </View>
                    </Tooltip>
                </View>
            </View>
            )
        } else {
            if(prompt){
                return(
                    <View style={styles.container}>
                        <View style={{alignItems: 'center'}}>
                            <Image source={appLogo ? appLogo :  Images.logo} style={styles.logo} resizeMode="contain"/>
                        </View>
                        <Text>Click below to install the app</Text>
                        <Button title="Install"
                                onPress={() => onInstallPress(prompt)}
                                style={{backgroundColor: 'black', marginTop:25}}
                        >
                            <Text style={styles.installText}>Install</Text>
                        </Button>
                    </View>
                )
            }
            else {
                return(
                    <View style={styles.container}>
                        <View style={{alignItems: 'center'}}>
                            <Image source={appLogo ? appLogo :  Images.logo} style={styles.logo} resizeMode="contain"/>
                        </View>
                        <Text>Click below to install the app</Text>
                        <ActivityIndicator
                            size="large"
                            color="#27aef1"
                            style={styles.loading}
                        />
                    </View>
                )
            }
        }

    } else {
        return(
            <View>
                <View style={{flex: 1}}>
                    <Text>Please refresh your page</Text>
                </View>
            </View>
        )
    }
}